import { c as _c } from "react/compiler-runtime";
import type { ImgHTMLAttributes } from "react";
type SvgImageProps = Pick<ImgHTMLAttributes<HTMLImageElement>, "alt" | "className" | "height" | "onError" | "onLoad" | "src" | "width">;
export function SvgImage(t0) {
  const $ = _c(8);
  const {
    alt,
    className,
    height,
    onError,
    onLoad,
    src,
    width
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== className || $[2] !== height || $[3] !== onError || $[4] !== onLoad || $[5] !== src || $[6] !== width) {
    t1 = <img alt={alt} className={className} height={height} onError={onError} onLoad={onLoad} src={src} width={width} />;
    $[0] = alt;
    $[1] = className;
    $[2] = height;
    $[3] = onError;
    $[4] = onLoad;
    $[5] = src;
    $[6] = width;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}